// extracted by mini-css-extract-plugin
export default {"resendButton":"PunchupLotteryTable_resendButton__2cjy7","emptyCell":"PunchupLotteryTable_emptyCell__Sa6ek"};